export default "/images/command.svg?2531129b1ccfa8584252aceb63a2f08e";